import { CSSProperties } from 'react';
import { Pill, PillColor } from '@shared/components/pill';

interface TagProps {
  label: string;
  color?: PillColor;
  archived?: boolean;
  style?: CSSProperties;
  textStyle?: CSSProperties;
}

export function Tag({ label, color, archived, style, textStyle }: Readonly<TagProps>) {
  return (
    <Pill
      round
      italic={archived}
      backgroundColor={archived ? 'backgroundGrayLight' : color}
      style={style}
      textStyle={textStyle}
    >
      {label}
    </Pill>
  );
}
